module.exports = __webpack_public_path__ + "static/media/Flag.3f21dd97.svg";